module.exports = __webpack_public_path__ + "static/media/popup-start.4239cb02.png";